import makeModalStore from "stores/utils/storeMakers/makeModalStore";

const useModalSecondStore = makeModalStore();

export { useModalSecondStore };
